import { Howl } from 'howler';
import { useGameStore } from '../stores/gameStore';

// Simple retro beep sounds (mono, short)
// Using minimal data URIs for retro beeps
const beepData = 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcAgAA';

// Lazy initialization: only create sounds after user interaction
let soundsInitialized = false;
let sounds: {
  moveBeep: Howl;
  eatBeep: Howl;
  deathTone: Howl;
  menuBeep: Howl;
  uiClick: Howl;
} | null = null;

const initSounds = () => {
  if (soundsInitialized || sounds) return;
  
  try {
    sounds = {
      moveBeep: new Howl({ 
        src: [beepData], 
        volume: 0.3,
        rate: 1.2 
      }),
      eatBeep: new Howl({ 
        src: [beepData], 
        volume: 0.6,
        rate: 1.5 
      }),
      deathTone: new Howl({ 
        src: [beepData], 
        volume: 0.5,
        rate: 0.6 
      }),
      menuBeep: new Howl({ 
        src: [beepData], 
        volume: 0.4,
        rate: 1.0 
      }),
      uiClick: new Howl({ 
        src: [beepData], 
        volume: 0.5,
        rate: 1.1 
      })
    };
    soundsInitialized = true;
  } catch (e) {
    console.warn('Audio initialization failed:', e);
  }
};

// Initialize sounds on first user interaction
if (typeof window !== 'undefined') {
  const initOnInteraction = () => {
    initSounds();
    window.removeEventListener('click', initOnInteraction);
    window.removeEventListener('touchstart', initOnInteraction);
    window.removeEventListener('keydown', initOnInteraction);
  };
  window.addEventListener('click', initOnInteraction, { once: true });
  window.addEventListener('touchstart', initOnInteraction, { once: true });
  window.addEventListener('keydown', initOnInteraction, { once: true });
}

const isSoundEnabled = () => useGameStore.getState().soundEnabled;

export const playMoveBeep = () => {
  if (!isSoundEnabled()) return;
  initSounds(); // Ensure sounds are initialized on first play
  sounds?.moveBeep.play();
};

export const playEatBeep = () => {
  if (!isSoundEnabled()) return;
  initSounds();
  sounds?.eatBeep.play();
};

export const playDeathTone = () => {
  if (!isSoundEnabled()) return;
  initSounds();
  sounds?.deathTone.play();
};

export const playMenuBeep = () => {
  if (!isSoundEnabled()) return;
  initSounds();
  sounds?.menuBeep.play();
};

export const playClick = () => {
  if (!isSoundEnabled()) return;
  initSounds();
  sounds?.uiClick.play();
};

// Legacy exports for compatibility
export const playPerfect = playEatBeep;
export const playMiss = playDeathTone;
export const playStreak = playEatBeep;
export const startBgLoop = () => {}; // No background music for retro feel
export const stopBgLoop = () => {};
